<template>
  <div class="landing_slider_container official">
    <div class="landing_slider">
      <div v-if="events.data">
        <div class="landing_slider_title">
          <i class="sp-ic-sm-land-official-icon" />
          Featured <b>Events</b>
          <calendar-marquees v-if="!checkMobileDevice()" style="margin-left: 15px" :type="marqueesType" @change-type="changeTypeMarquees" />
          <div v-if="!checkMobileDevice()" class="landing_event_btn" style="margin-left: auto; margin-right: 135px;">
            <a
              class="view_all_event"
              :href="routePubgEvents()"
              style="position:static; color: white; display: flex; align-items: center; justify-content: center;"
            >VIEW ALL EVENTS</a>
          </div>
        </div>
        <keep-alive>
          <event-slider v-if="events.data.count > 0 && marqueesType === 'grid'" :events="events" :is-grid-view="false" page="landing" />
        </keep-alive>
        <keep-alive>
          <event-calendar v-if="!checkMobileDevice() && marqueesType === 'calendar'" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../../mixins/component';
import EventSlider from '../../../../../components/events/EventSlider';
import CalendarMarquees from '../../../../../components/shared/CalendarMarquees';
import EventCalendar from '../../../../../components/events/EventCalendar';
import { EventBus, CLOSE_EVENT_CALENDAR } from '../../../../../event-bus';

export default {
  components: { EventSlider, CalendarMarquees, EventCalendar },
  mixins: [component],
  props: {
    events: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      marqueesType: 'grid',
    };
  },
  created() {
    EventBus.$on(CLOSE_EVENT_CALENDAR, this.closeEventCalendar);
  },
  destroyed() {
    EventBus.$off(CLOSE_EVENT_CALENDAR);
  },
  methods: {
    changeTypeMarquees(type) {
      this.marqueesType = type;
    },
    closeEventCalendar() {
      this.marqueesType = 'grid';
    },
  },
};
</script>
